import InternalRoutes from './InternalRoutes'
import FloorPlanRoutes from './FloorPlanRoutes'

export { FloorPlanRoutes }

//export { default as FloorPlanRoutes } from './FloorPlanRoutes'

export default InternalRoutes
